import { LoadPanel, TreeList, CheckBox, Button } from "devextreme-react";
import { Column } from "devextreme-react/tree-list";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addProjectsApi,
  getAllCatSubCatObjectApi,
} from "../../../api/companyCustomerApi";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CancelSaveHeader from "../../../components/customPageHeader/CancelSaveHeader";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import "./AssignProjects.scss";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";

export default function AssignProjects() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { custdata } = location.state || {};
  const [allData, setAllData] = useState([]);
  const navigate = useNavigate();

  /* ================= FETCH DATA ================= */

  const fetchCatSubCatObject = async () => {
    try {
      setLoading(true);

      const result = await getAllCatSubCatObjectApi(
        custdata?.companytransid,
        custdata?.transid,
      );

      const transformData = [];
      const filteredCategories = result?.data?.data?.filter(
        (category) => category.subcategories?.length > 0,
      );

      filteredCategories.forEach((category) => {
        const catId = `CAT_${category.transid}`;

        transformData.push({
          ID: catId,
          Head_ID: 0,
          Category_Name: category.ticketcategoryname,
          actualId: category.transid,
          type: "category",
          isSelected: category.selected || false,
        });

        category?.subcategories?.forEach((sub) => {
          transformData.push({
            ID: `SUB_${sub.transid}`,
            Head_ID: catId,
            Category_Name: sub.ticketsubcatname,
            actualId: sub.transid,
            type: "subcategory",
            isSelected: sub.selected || false,
          });
        });
      });

      setAllData(transformData);
    } catch (error) {
      ToastDisplayer("error", "Unable to fetch records!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (custdata?.companytransid && custdata?.transid) {
      fetchCatSubCatObject();
    }
  }, [custdata]);

  /* ================= SELECTION LOGIC ================= */

  const updateSelection = (items, targetId, newValue) => {
    return items
      .map((item) => {
        // Clicked item
        if (item.ID === targetId) {
          // If Parent → update children
          if (item.type === "category") {
            return {
              ...item,
              isSelected: newValue,
            };
          }
          // If Child
          return { ...item, isSelected: newValue };
        }

        // If parent → check children state
        if (item.type === "category") {
          const children = items.filter((x) => x.Head_ID === item.ID);

          const anyChildSelected = children.some((child) =>
            child.ID === targetId ? newValue : child.isSelected,
          );

          return {
            ...item,
            isSelected: anyChildSelected,
          };
        }

        return item;
      })
      .map((item) => {
        // Parent click → update children separately
        const clickedItem = items.find((x) => x.ID === targetId);

        if (clickedItem?.type === "category" && item.Head_ID === targetId) {
          return { ...item, isSelected: newValue };
        }

        return item;
      });
  };

  const handleCheckboxChange = (id, value) => {
    const updated = updateSelection(allData, id, value);
    setAllData(updated);
  };

  /* ================= SAVE ================= */

  const addProjectsData = async () => {
    try {
      setLoading(true);

      const selectedItems = allData.filter((x) => x.isSelected);

      let categoryid = new Set();
      let subcategoryid = new Set();

      selectedItems.forEach((item) => {
        if (item.type === "category") {
          categoryid.add(item.actualId);
        } else {
          subcategoryid.add(item.actualId);
        }
      });

      const payload = {
        companyid: custdata?.companytransid,
        custid: custdata?.transid,
        categoryid: Array.from(categoryid),
        subcategoryid: Array.from(subcategoryid),
      };

      const result = await addProjectsApi(payload);

      if (result.status === 201) {
        ToastDisplayer("success", "Projects assigned successfully!");
        navigate("/client");
      }
    } catch (error) {
      ToastDisplayer("error", "Error while saving.");
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    navigate(-1);
  };
  /* ================= UI ================= */

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="projPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-task-line"></i>
              </span>
              {/* <p>Assign Projects</p> */}
              <BreadCrumb />
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleCancel}
            />

            <Button
              className="saveBtn"
              text="Save Details"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={addProjectsData}
            />

            {/* <CustomPageHeader
              // titleName={"Customers"}
              handleCreateNew={handleCreateNew}
              btnText={"Add Client"}
            /> */}
          </div>
        </div>
        {/* <AddNewSubHeader
          titleName={`Assign Projects`}
          handleSaveDetails={addProjectsData}
          handleCancel={handleCancel}
          cancelText={"Cancel"}
          saveText={"Save Details"}
          iconClass={"ri-task-line"}
        /> */}

        <div className="projMain">
          <div className="mainAddCustSection middlePart">
            {allData?.length > 0 && (
              <TreeList
                dataSource={allData}
                keyExpr="ID"
                parentIdExpr="Head_ID"
                showRowLines={true}
                showBorders={false}
                columnAutoWidth={true}
              >
                <Column
                  width="400"
                  dataField="Category_Name"
                  caption={`Project List for ${custdata?.custname || ""}`}
                />

                <Column
                  caption="Select"
                  // width={100}
                  cellRender={(cellData) => (
                    <CheckBox
                      value={cellData.data.isSelected}
                      onValueChanged={(e) =>
                        handleCheckboxChange(cellData.data.ID, e.value)
                      }
                    />
                  )}
                />
              </TreeList>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
